<template>
  <div class="eventReserveBox">
    <div>{{title}}</div>
    <div>
      <div>
        <div>大人</div>
        <div :style="{color}">{{AD||0}}</div>
      </div>
      <div>
        <div>小孩</div>
        <div :style="{color}">{{CH||0}}</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['title', 'AD', 'CH', 'color']

}
</script>

<style lang="scss" scoped>
.eventReserveBox {
  display: flex;
  flex-direction: column;
  padding: 23px 42px 22px 35px;
  gap: 15px;
  &>div:nth-child(1) {
    text-align: start;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 15px;
    letter-spacing: 2px;
    color: #5E5E5E;

  }
  &>div:nth-child(2) {
    display: flex;
    flex-direction: row;
    gap: 24px;
    &>div{
      width: 160px;
      height: 105px;
      display: flex;
      flex-direction: column;
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
      border-radius: 5px;
      align-items: center;
      justify-content: center;
      gap: 10px;
      background-color: #FFFFFF;
      &>div:nth-child(1) {
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 20px;
        text-align: center;
        letter-spacing: 2px;
        color: #848484;
      }
      &>div:nth-child(2) {
        color: var(--color-checked);
        font-style: normal;
        font-weight: 500;
        font-size: 40px;
        line-height: 40px;
        /* or 38% */

        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 2px;

      }
    }
  }
}
</style>
